/* Types */
export type TooltipPosition =
  | "top"
  | "top-start"
  | "top-end"
  | "bottom"
  | "bottom-start"
  | "bottom-end"
  | "left"
  | "left-start"
  | "left-end"
  | "right"
  | "right-start"
  | "right-end";

/* Constants */
export const ARROW_GAP = 12;

export const ARROW_STYLES: Record<TooltipPosition, string> = {
  top: "after:absolute after:top-full after:left-1/2 after:-translate-x-1/2 after:border-8 after:border-transparent after:border-t-base-100",
  "top-start": "after:absolute after:top-full after:left-4 after:border-8 after:border-transparent after:border-t-base-100",
  "top-end": "after:absolute after:top-full after:right-4 after:border-8 after:border-transparent after:border-t-base-100",
  bottom: "after:absolute after:bottom-full after:left-1/2 after:-translate-x-1/2 after:border-8 after:border-transparent after:border-b-base-100",
  "bottom-start": "after:absolute after:bottom-full after:left-4 after:border-8 after:border-transparent after:border-b-base-100",
  "bottom-end": "after:absolute after:bottom-full after:right-4 after:border-8 after:border-transparent after:border-b-base-100",
  left: "after:absolute after:left-full after:top-1/2 after:-translate-y-1/2 after:border-8 after:border-transparent after:border-l-base-100",
  "left-start": "after:absolute after:left-full after:top-4 after:border-8 after:border-transparent after:border-l-base-100",
  "left-end": "after:absolute after:left-full after:bottom-4 after:border-8 after:border-transparent after:border-l-base-100",
  right: "after:absolute after:right-full after:top-1/2 after:-translate-y-1/2 after:border-8 after:border-transparent after:border-r-base-100",
  "right-start": "after:absolute after:right-full after:top-4 after:border-8 after:border-transparent after:border-r-base-100",
  "right-end": "after:absolute after:right-full after:bottom-4 after:border-8 after:border-transparent after:border-r-base-100",
};

export const TRANSLATE_CLASSES: Record<TooltipPosition, string> = {
  top: "-translate-x-1/2 -translate-y-full",
  "top-start": "-translate-y-full",
  "top-end": "-translate-x-full -translate-y-full",
  bottom: "-translate-x-1/2",
  "bottom-start": "",
  "bottom-end": "-translate-x-full",
  left: "-translate-x-full -translate-y-1/2",
  "left-start": "-translate-x-full",
  "left-end": "-translate-x-full -translate-y-full",
  right: "-translate-y-1/2",
  "right-start": "",
  "right-end": "-translate-y-full",
};

export const TRANSFORM_ORIGINS: Record<TooltipPosition, string> = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "center right",
  "left-start": "top right",
  "left-end": "bottom right",
  right: "center left",
  "right-start": "top left",
  "right-end": "bottom left",
};

/* Helpers */
export const calculateCoords = (rect: DOMRect, position: TooltipPosition) => {
  const positionMap: Record<TooltipPosition, { top: number; left: number }> = {
    top: { top: rect.top - ARROW_GAP, left: rect.left + rect.width / 2 },
    "top-start": { top: rect.top - ARROW_GAP, left: rect.left },
    "top-end": { top: rect.top - ARROW_GAP, left: rect.right },
    bottom: { top: rect.bottom + ARROW_GAP, left: rect.left + rect.width / 2 },
    "bottom-start": { top: rect.bottom + ARROW_GAP, left: rect.left },
    "bottom-end": { top: rect.bottom + ARROW_GAP, left: rect.right },
    left: { top: rect.top + rect.height / 2, left: rect.left - ARROW_GAP },
    "left-start": { top: rect.top, left: rect.left - ARROW_GAP },
    "left-end": { top: rect.bottom, left: rect.left - ARROW_GAP },
    right: { top: rect.top + rect.height / 2, left: rect.right + ARROW_GAP },
    "right-start": { top: rect.top, left: rect.right + ARROW_GAP },
    "right-end": { top: rect.bottom, left: rect.right + ARROW_GAP },
  };
  return positionMap[position];
};
